import React from "react";
import "../../css/Home.css";
import Hero from "../../components/Hero";
import Promos from "../../components/Promos";
import Reviews from "../../components/Reviews";
import Footer from "../../components/Footer";
import Evaluated from "../../components/Evaluated";
import ProfileSection from "../../components/ProfileSection";
import Squad from "../../components/SquadNew";

function Home() {
  return (
    <>
      <Hero />
      <ProfileSection />
      <Promos />
      <Evaluated />
      <Reviews />
      <Squad />
      <Footer />
    </>
  );
}

export default Home;
